module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pending_reviews":"Writeable Reviews {count}","written_reviews":"My Reviews {count}"}}')
  delete Component.options._Ctor
}
